import { useRef } from "react";
import type { FederatedPointerEvent } from "pixi.js";
import { hasReachedDragThreshold } from "../Functions/hasReachedDragThreshold";

export function usePointerDrag(dragThresholdPx: number) {
  const isDraggingRef = useRef(false);
  const isPointerDownRef = useRef(false);
  const pointerDownPositionRef = useRef<{ x: number; y: number } | null>(null);

  const handlePointerDown = (event: FederatedPointerEvent) => {
    isPointerDownRef.current = true;
    isDraggingRef.current = false;
    pointerDownPositionRef.current = {
      x: event.global.x,
      y: event.global.y
    };
  };

  const handlePointerMove = (event: FederatedPointerEvent) => {
    if (
      isPointerDownRef.current &&
      pointerDownPositionRef.current &&
      hasReachedDragThreshold(pointerDownPositionRef.current, event.global, dragThresholdPx)
    ) {
      isDraggingRef.current = true;
    }
  };

  const resetPointerGesture = () => {
    isDraggingRef.current = false;
    isPointerDownRef.current = false;
    pointerDownPositionRef.current = null;
  };

  return {
    hasDragged: () => isDraggingRef.current,
    handlePointerDown,
    handlePointerMove,
    resetPointerGesture
  };
}
